import React from 'react'

const CartContentContext = React.createContext(null)

export const Provider = CartContentContext.Provider
export const Consumer = CartContentContext.Consumer

export default CartContentContext
